import FancysSetting from './FancysSetting';

export default FancysSetting;